import { render, staticRenderFns } from "./PayslipCard.vue?vue&type=template&id=043f6978"
import script from "./PayslipCard.vue?vue&type=script&lang=js"
export * from "./PayslipCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports